import Accounts from './accounts';
import S3Analytics from './s3Analytics';
import CostBreakdown from './costBreakdown';
import Reports from './reports';
import Resources from './resources';
import Map from './map';
import Tags from './tags';

export default {
  Accounts,
  S3Analytics,
  CostBreakdown,
  Reports,
  Map,
  Resources,
  Tags
};



// WEBPACK FOOTER //
// ./src/components/aws/index.js